import SearchUser from './SearchUser'

export default SearchUser
